import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LessonState } from '../reducers/lesson.reducer';
import { LESSON_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LessonState>(LESSON_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: LessonState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectState, (state: LessonState) => (state.items[id] ? state.items[id].loading : false));
export const selectLesson = (id: string) => createSelector(selectState, (state: LessonState) => (state.items[id] ? state.items[id].data : null));
